import { useTranslation, Trans } from 'react-i18next';
import classNames from 'classnames';

import useSetPageTitle from '../../shared/hooks/useSetPageTitle/useSetPageTitle';

import termsAndConditionsImg from '../../images/terms-and-conditions.png';

import commonStyles from '../../shared/styles/index.module.scss';

const TermsAndConditions = () => {
  const { t } = useTranslation();

  useSetPageTitle({
    pageTitle: `${t('pages.terms-and-conditions')} | ${t('general.website-name')}`,
  });

  return (
    <div className={commonStyles.container}>
      <div
        className={classNames(
          commonStyles.legalPageHeader,
          commonStyles.container,
        )}>
        <div>
          <h1 className={commonStyles.legalPageTitle}>
            {t('terms-and-conditions.title')}
          </h1>
        </div>
        <div>
          <img
            src={termsAndConditionsImg}
            alt={t('terms-and-conditions.title')}
            loading='lazy'
          />
        </div>
      </div>
      <div
        className={classNames(
          commonStyles.legalPageContent,
          commonStyles.container,
        )}>
        <div className={commonStyles.legalPageContentBlock}>
          <p className={commonStyles.legalPageContentRow}>
            <Trans i18nKey='terms-and-conditions.section-one.line-one' />
          </p>
        </div>
        <div className={commonStyles.legalPageContentBlock}>
          <h4 className={commonStyles.legalPageContentHeadline}>
            {t('terms-and-conditions.section-two.title')}
          </h4>
          <p className={commonStyles.legalPageContentRow}>
            <Trans i18nKey='terms-and-conditions.section-two.line-one' />
          </p>
          <p>{t('terms-and-conditions.section-two.line-two')}</p>
        </div>
        <div className={commonStyles.legalPageContentBlock}>
          <h4 className={commonStyles.legalPageContentHeadline}>
            {t('terms-and-conditions.section-three.title')}
          </h4>
          <p className={commonStyles.legalPageContentRow}>
            {t('terms-and-conditions.section-three.line-one')}
          </p>
        </div>
        <div className={commonStyles.legalPageContentBlock}>
          <h4 className={commonStyles.legalPageContentHeadline}>
            {t('terms-and-conditions.section-four.title')}
          </h4>
          <p className={commonStyles.legalPageContentRow}>
            <Trans i18nKey='terms-and-conditions.section-four.line-one' />
          </p>
        </div>
        <div className={commonStyles.legalPageContentBlock}>
          <h4 className={commonStyles.legalPageContentHeadline}>
            {t('terms-and-conditions.section-five.title')}
          </h4>
          <p className={commonStyles.legalPageContentRow}>
            <Trans i18nKey='terms-and-conditions.section-five.line-one' />
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
